<template>

  <div v-if="showPwaBtn"
       :class="isMobile ? 'pwa-install-mobile-top-layer':'pwa-install-desktop-top-layer'">
    <div class="toast-container">
      <div class="cancel-icon">
        <b-icon icon="x" @click="dismiss"></b-icon>
      </div>
      <div class="toast-content">
        <div class="toast-title" v-html="'EliteFit.AI'"></div>
        <div class="toast-text" v-html="'Get our free app. It won\'t take up space on your device.'"></div>
      </div>
      <div class="toast-install"> <b-button pill @click="installAsPwa">Install</b-button> </div>
    </div>
  </div>
</template>
<script>
import Cookies from "js-cookie";
import UserService from "@/module_user/api/user-service";

export default {
  name: "InstallPwa",
  data() {
    return {
      disableOnPages: ['workout', 'workoutIntro'],
      showPwaBtn: false,
      installPrompt: null,
      reminder: 1, // 1 days
    }
  },
  computed: {
    isMobile() {
      const isAndroid = /Android/i.test(navigator.userAgent);
      const isiOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
      return isAndroid || isiOS;
    },
  },
  methods: {
    installAsPwa() {
      // hide the install button
      this.showPwaBtn = false;
      // show the prompt
      this.installPrompt.prompt();
      // wait for the user to respond to the prompt
      this.installPrompt.userChoice.then(result => {
        if (result.outcome === 'accepted') {
          this.installPrompt = null;
        }
        else this.dismiss();
      })

    },
    async dismiss () {
      // for now disabling cookies based timed popup.
      // Cookies.set("add-to-home-screen", null, { expires: this.reminder });
      this.installPrompt = null;
      this.showPwaBtn = false;
      this.$log.debug('User denied to install pwa.')
    },
    checkForPrompt() {
      const activePage = this.$route.path;
      if (this.disableOnPages.some(page => activePage.includes(page))) {
        this.showPwaBtn = false;
        return;
      }
      if (this.installPrompt) {
        this.showPwaBtn = true;
      }
    }
  },
  created() {
    // Disabling for now
    return;
    window.addEventListener("beforeinstallprompt", e => {
      // Prevent Chrome 67 and earlier from automatically showing the prompt
      e.preventDefault();
      // Stash the event so it can be triggered later.
      // for now disabling cookies based timed popup.
      // if (Cookies.get("add-to-home-screen") === undefined) {
      //   this.installPrompt = e;
      //   // Update UI notify the user they can add to home screen
      //   this.showPwaBtn = true;
      // }
      let activePage = this.$route.name;
      if (this.disableOnPages.includes(activePage)) return;
      this.installPrompt = e;
      // Update UI notify the user they can add to home screen
      this.showPwaBtn = true;
    });

    window.addEventListener('appinstalled', (event) => {
      this.showPwaBtn = false;
      this.installPrompt = null;
      UserService.recordPwaInstall();
      this.$log.debug('User accepted to install pwa.');
    });
  },
  watch: {
    $route() {
      this.checkForPrompt()
    }
  }
}
</script>
<style lang="scss" scoped>
.pwa-install-desktop-top-layer {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: end;
  pointer-events: none;
  position: fixed;
  z-index: 99999;
  width: 100%;
  bottom: 5px;
  height: 80px;
}
.pwa-install-mobile-top-layer {
  display: flex;
  flex-direction: row;
  align-items: start;
  justify-content: center;
  pointer-events: none;
  position: fixed;
  z-index: 99999;
  width: 100%;
  height: 80px;
  top: 10px;
}

.toast-container {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  text-align: left;
  font-size: 1rem;
  margin: 5px 5px 0 5px;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
  width: max-content;
  background: #73bc45;
  color: #FFFFFF;

  .cancel-icon {
    flex: 0 1 auto;
    font-size: 2.5rem;
    padding: 0 10px;
    cursor: pointer;
    &:hover {
      color: rgb(237, 28, 36);
    }
  }
  .toast-content {
    padding: 10px;
    .toast-title {
      letter-spacing: 1px;
      text-transform: none;
      font-weight: 600;
    }
  }
  .toast-install {
    flex: 0 1 auto;
    padding: 0 10px;
    cursor: pointer;
    color: #000000;
    .btn-secondary {
      color: black;
      background-color: white;
      padding: 0.6rem 1rem;
      border-color: white;
      box-shadow: 0px 16px 49px rgba(20, 21, 19, 0.15);
      font-weight: 600;
      &:hover {
        border-color: #afb4bb;
      }
    }
  }
}
</style>
